import { maskitoTransform } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import React from 'react';

export const numberMaskOptions = maskitoNumberOptionsGenerator({
    thousandSeparator: ' ',
});

export function useInputMask(value: string) {
    const inputRef = useMaskito({
        options: numberMaskOptions,
    });

    const [maskedValue, setMaskedValue] = React.useState(() =>
        maskitoTransform(value, numberMaskOptions),
    );

    React.useEffect(
        () => setMaskedValue(maskitoTransform(value, numberMaskOptions)),
        [value],
    );

    const [unmaskedValue, setUnmaskedValue] = React.useState(value);

    React.useEffect(
        () => setUnmaskedValue(maskedValue.replace(/\s+/g, '')),
        [maskedValue],
    );

    return {
        inputRef,
        maskedValue,
        setMaskedValue,
        unmaskedValue,
    };
}
